
import { defineComponent, PropType } from 'vue';
import { FieldConfig } from '@/types';
import NoticeBox from '@/components/template-builder/panels/NoticeBox.vue';

export default defineComponent({
  name: 'Notice',

  components: {
    NoticeBox,
  },

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },
  },
});
